import { Component, effect, input, InputSignal } from '@angular/core';

@Component({
  selector: 'icon-sound',
  standalone: true,
  template: `
    <svg [class.disabled]="disabled()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
        <path d="M10.6668 6.00006C11.0996 6.57705 11.3335 7.27883 11.3335 8.00006C11.3335 8.72129 11.0996 9.42307 10.6668 10.0001M12.9095 12.2427C13.4667 11.6856 13.9086 11.0241 14.2102 10.2962C14.5117 9.56822 14.6669 8.788 14.6669 8.00006C14.6669 7.21212 14.5117 6.4319 14.2102 5.70394C13.9086 4.97598 13.4667 4.31455 12.9095 3.75739M7.3335 3.13473C7.33336 3.04187 7.30572 2.95113 7.25407 2.87396C7.20242 2.7968 7.12906 2.73666 7.04327 2.70114C6.95747 2.66563 6.86307 2.65632 6.77199 2.6744C6.68091 2.69248 6.59722 2.73713 6.5315 2.80273L4.2755 5.05806C4.18843 5.14564 4.08485 5.21508 3.97076 5.26234C3.85666 5.3096 3.73432 5.33375 3.61083 5.33339H2.00016C1.82335 5.33339 1.65378 5.40363 1.52876 5.52866C1.40373 5.65368 1.3335 5.82325 1.3335 6.00006V10.0001C1.3335 10.1769 1.40373 10.3464 1.52876 10.4715C1.65378 10.5965 1.82335 10.6667 2.00016 10.6667H3.61083C3.73432 10.6664 3.85666 10.6905 3.97076 10.7378C4.08485 10.785 4.18843 10.8545 4.2755 10.9421L6.53083 13.1981C6.59656 13.2639 6.68037 13.3088 6.77162 13.327C6.86288 13.3452 6.95748 13.3359 7.04345 13.3002C7.12941 13.2646 7.20286 13.2043 7.2545 13.1269C7.30613 13.0494 7.33363 12.9584 7.3335 12.8654V3.13473Z" stroke="#2A4B5A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
        padding: 4px;

        path{
            stroke: #0006;
            -webkit-transition: all .15s linear;
            -moz-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;
        }

        &:hover{
            /* path{
                stroke: #11B7B7;
            } */
            background: rgba(0, 0, 0, 0.05);

        }

        &.disabled{
            cursor: not-allowed;
            path{
                stroke: #2A4B5A;
            }
        }
    }
  `
})
export class SoundIconComponent {
    public disabled: InputSignal<boolean> = input.required<boolean>();
}
